/**
 * Digits only. Strips `+`, spaces, dashes, etc., so each value can be with or without leading `+`
 * and still compare equal when they are the same number.
 */
export const digitsOnlyPhone = (value) => String(value || '').replace(/\D/g, '');

/**
 * True if two phone strings refer to the same line when one may omit the country code
 * (e.g. +593961371400 vs 961371400, or +593… vs 593… — `+` on either side is ignored).
 *
 * For international use we combine:
 * - minSuffixDigits: national numbers are rarely shorter than this (8 covers e.g. SG 8-digit nationals).
 * - maxLeadingDigitGap: suffix match only if the longer string is 1..N digits longer than the shorter.
 *   Country calling codes are 1–3 digits (ITU); N=4 leaves margin for odd formatting. This avoids
 *   matching unrelated numbers that merely share a long trailing digit sequence.
 */
export const phoneNumbersLooselyMatch = (a, b, options = {}) => {
  const minSuffixDigits = options.minSuffixDigits ?? 8;
  const maxLeadingDigitGap = options.maxLeadingDigitGap ?? 4;

  const da = digitsOnlyPhone(a);
  const db = digitsOnlyPhone(b);
  if (!da || !db) return false;
  if (da === db) return true;

  const shorter = da.length <= db.length ? da : db;
  const longer = da.length <= db.length ? db : da;
  if (shorter.length < minSuffixDigits) return false;

  const leadingDigitGap = longer.length - shorter.length;
  if (leadingDigitGap < 1 || leadingDigitGap > maxLeadingDigitGap) return false;

  return longer.endsWith(shorter);
};

export const visiblePhoneNumber = (phone, currentRetailerUser, slice = 7) => {
  if (!phone || phone.length < 5) return phone || '';

  // Use new permission system: can_view_phone_numbers now returns can_view_phone_numbers from serializer
  const canViewPhone = currentRetailerUser.can_view_phone_numbers ?? currentRetailerUser.see_phone_numbers;
  if (!canViewPhone) {
    return phone.slice(0, slice) + '*'.repeat(Math.max(phone.length - slice, 0));
  }

  return phone;
};
